// extracted by mini-css-extract-plugin
export default {"popupListWrap":"PopupList_popupListWrap__58RSk","popupList":"PopupList_popupList__RN1QX","list":"PopupList_list__vTcN9","title":"PopupList_title__KbqQf"};